"use client";

import { emptyState } from "../../assets";

const EmptyState = ({ children }) => {
  const containerStyle = {
    display: "flex",
    width: "100%",
    flexDirection: "column",
    fontSize: "1.7rem",
    alignItems: "center",
    gap: "1rem",
    padding: "1.5rem",
  };

  const textStyle = {
    color: "#504f4f",
    textAlign: "center",
  };

  return (
    <div style={containerStyle}>
      <p style={textStyle}>{children}</p>
      <div>{emptyState}</div>
    </div>
  );
};

export default EmptyState;
